import React from 'react';

const SvgMn = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MN_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="MN_svg__c">
        <stop stopColor="#F8D246" offset="0%" />
        <stop stopColor="#F9CE2F" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MN_svg__b" fill="#fff">
        <use xlinkHref="#MN_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#MN_svg__a" />
      <path
        fill="#146BBC"
        mask="url(#MN_svg__b)"
        d="M9.333 0h9.333v20H9.333z"
      />
      <path
        fill="#E43642"
        mask="url(#MN_svg__b)"
        d="M0 0h9.333v20H0zM18.667 0H28v20h-9.333z"
      />
      <path
        d="M5.333 12h1.334v4H5.333v-4zm-2.666 0H4v4H2.667v-4zM4 14.667h1.333L4.667 16 4 14.667zM4 12h1.333l-.666 1.333L4 12zm0-1.333L4.667 10l.666.667H4zM4.667 12a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zm0 2.667a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334z"
        fill="url(#MN_svg__c)"
        mask="url(#MN_svg__b)"
      />
    </g>
  </svg>
);

export default SvgMn;
